export default "__VITE_ASSET__B_NCzr0$__"